/**
 * SVG transform matching Konva's `T(x,y) · R(θ) · S(sX, sY)` pipeline for
 * content drawn at world coordinates (anchored with `x={shape.x}`). The
 * trailing `translate(-x, -y)` brings that content into local space so
 * rotation and scale compose about the shape origin, as in the editor.
 */
export const buildWorldShapeTransform = (shape: {
  x: number;
  y: number;
  rotation?: number;
  scaleX?: number;
  scaleY?: number;
}): string | undefined => {
  const rotation = shape.rotation || 0;
  const scaleX = shape.scaleX || 1;
  const scaleY = shape.scaleY || 1;
  if (rotation === 0 && scaleX === 1 && scaleY === 1) return undefined;
  return `translate(${shape.x}, ${shape.y}) rotate(${rotation}) scale(${scaleX}, ${scaleY}) translate(${-shape.x}, ${-shape.y})`;
};

/** Same pipeline for content drawn at the local origin. */
export const buildLocalShapeTransform = (shape: {
  x: number;
  y: number;
  rotation?: number;
  scaleX?: number;
  scaleY?: number;
}): string => {
  const scaleX = shape.scaleX || 1;
  const scaleY = shape.scaleY || 1;
  const rotationPart = shape.rotation ? ` rotate(${shape.rotation})` : "";
  const scalePart =
    scaleX !== 1 || scaleY !== 1 ? ` scale(${scaleX}, ${scaleY})` : "";
  return `translate(${shape.x}, ${shape.y})${rotationPart}${scalePart}`;
};
